// extracted by mini-css-extract-plugin
export var divider = "_pq-0";
export var systemMessage = "_pq-1";